import { UberDeliveryStatus } from '~/graphql/generated/graphql';

// 当日配達の利用料が確定しているステータス
const feeFixedStatuses: UberDeliveryStatus[] = [
  'dropoff',
  'delivered',
  'canceled',
  'return_delivered',
];

/**
 * 当日配達の利用料が確定しているかどうか
 * 確定するまでは会計できない
 */
export const isUberDeliveryFeeFixed = (status: UberDeliveryStatus | undefined) =>
  !!status && feeFixedStatuses.includes(status);
